export enum ExternalVendor {
  PLANNING_CENTER = 'PLANNING_CENTER',
  SMART_WAIVER = 'SMART_WAIVER'
}
